<div class="autocomplete">
    <input class="form-control" [formControl]="control">
    <div *ngIf="(_completes | async)?.length && edition" class="autocomplete-modal"
        style="z-index: 99999999 !important;">
        <span *ngFor="let item of _completes | async " (click)="pickAutoCompleteItem(item)"
            (keypress)="$event.key === 'Enter'?pickAutoCompleteItem(item):null">{{item[keyword]}}</span>
    </div>
</div>